













































import { Component, Vue, Prop, InjectReactive, Watch, Ref } from 'vue-property-decorator';
import { GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import { GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import PaycheckDraftPeriodFormWorkRelation from './PaycheckDraftPeriodFormWorkRelation.vue';
import Altinn from '@/app/Altinn';
import { isEmployedDuringPeriod } from '@/app/WorkRelation';
import paycheckSettingsService from '@/utils/paycheck-settings-service';

@Component({
  components: {
    PaycheckDraftPeriodFormWorkRelation,
  },
})
export default class PaycheckDraftPeriodFormSubUnit extends Vue {
  @Prop({ type: Object, required: true }) private subUnit!: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits;
  @InjectReactive() private paycheckPeriod!: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods;

  @Ref() public workRelationRefs!: PaycheckDraftPeriodFormWorkRelation[];

  public get isExpanded() { return this.expanded }
  private expanded = true;

  private created(): void {
    this.expanded = !paycheckSettingsService.isExpandedSection(this.paycheckPeriod.id, this.subUnit.id);
  }

  @Watch('expanded')
  private onExpandChange(): void {
    paycheckSettingsService.expandSection(!this.expanded, this.paycheckPeriod.id, this.subUnit.id);
  }

  public expandEmployeesWithPaycheckDrafts(onSave = false): void {
    if (!this.workRelationRefs) return;

    const wrsToExpand = this.relevantWorkRelations
      .filter(wr => wr.paycheckDrafts.filter(draft => draft.active).length > 0);

    this.workRelationRefs.forEach(wrRef => {
      const workRelation = wrsToExpand.find(wr => wr.id === wrRef.workRelationId);
      if (workRelation) {
        if (onSave) {
          if (!wrRef.expandMeOnSave) return;
          setTimeout(() => { wrRef.expand(); wrRef.expandMeOnSave = false }, 0);
        } else {
          setTimeout(() => wrRef.expand(), 0);
        }
      }
    });
  }

  private get relevantWorkRelations(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations[] {
    return this.subUnit.workRelations.filter(workRelation =>
      workRelation.paycheckDrafts.length ||
      workRelation.paychecks.length ||
      (
        workRelation.employmentType !== Altinn.pensionEmploymentType && // isn't pension
        isEmployedDuringPeriod(workRelation, this.paycheckPeriod) // is employed
      ),
    );
  }
}
